import '../styles.css'
import './linkbio.css'
import React, { useState, useEffect } from 'react';


function LinkBio() {

  const [tabBio , setTabBio] = useState(null);

  useEffect(() => {
    const fetchLinkBio = async() => {
      const spreadsheetID = '1q59PIahkYp23fJK-CHRweIgQKHetP4to9xSU7gSrfIY'
      const sheetNameBio = 'Link da bio'
      const urlBio = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json&sheet=${sheetNameBio}`
      
      try {
        const response = await fetch(urlBio)
        .then(res => res.text())
        .then(text => JSON.parse(text.slice(47,-2)))
        setTabBio(response)

      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } 
    };
    fetchLinkBio();
  }, []);

  return (
    <div className="bio-container">
      <div className="bio-header">
        <img src="logomarrom.png" alt='' className="bio-logo" />
        <h2>Maracaju</h2>
        <p className="bio-description">{tabBio && tabBio.table.rows[1].c[0].v}</p>
      </div>
      
      <div className="bio-links">

      {tabBio && tabBio.table.rows.slice(1).map(
            (row,idx) => {
                return(
                  <a href={row.c[2].v} target="_blank" rel="noopener noreferrer" className="bio-link">
                    {row.c[1].v}              
                  </a>
                )
            }
          )
      }
      <a href='/' target="_blank" rel="noopener noreferrer" className="bio-link">
        Site oficial             
      </a>
      </div>
    </div>

  )
}

export default LinkBio


